import { useNavigate } from "react-router-dom";
import TideWeather from "./TideWeather";
import PageMeta from "./PageMeta";

const windyMarks = [
  { name: "Cape Cornwall",  type: "Shore",      lat: 50.127,  lon: -5.703 },
  { name: "Dodman Point",   type: "Shore",      lat: 50.216,  lon: -4.799 },
  { name: "Falmouth",       type: "Shore/Boat", lat: 50.154,  lon: -5.064 },
  { name: "Godrevy Point",  type: "Shore",      lat: 50.238,  lon: -5.397 },
  { name: "Gwennap Head",   type: "Shore",      lat: 50.038,  lon: -5.665 },
  { name: "Hayle",          type: "Shore",      lat: 50.183,  lon: -5.432 },
  { name: "Lizard Point",   type: "Shore",      lat: 49.958,  lon: -5.203 },
  { name: "Loe Bar",        type: "Shore",      lat: 50.063,  lon: -5.290 },
  { name: "Mawnan Smith",   type: "Shore",      lat: 50.115,  lon: -5.128 },
  { name: "Mount's Bay",    type: "Boat",       lat: 50.070,  lon: -5.470 },
  { name: "Mullion Cove",   type: "Shore/Boat", lat: 50.017,  lon: -5.260 },
  { name: "Newquay",        type: "Shore/Boat", lat: 50.412,  lon: -5.081 },
  { name: "Padstow",        type: "Shore/Boat", lat: 50.537,  lon: -4.937 },
  { name: "Perranporth",    type: "Shore",      lat: 50.343,  lon: -5.155 },
  { name: "Porthleven",     type: "Shore/Boat", lat: 50.083,  lon: -5.314 },
  { name: "Porthtowan",     type: "Shore",      lat: 50.281,  lon: -5.249 },
  { name: "Portreath",      type: "Shore",      lat: 50.263,  lon: -5.234 },
  { name: "Praa Sands",     type: "Shore",      lat: 50.097,  lon: -5.391 },
  { name: "Sennen Cove",    type: "Shore",      lat: 50.071,  lon: -5.699 },
  { name: "St Agnes Head",  type: "Shore",      lat: 50.302,  lon: -5.232 },
  { name: "St Ives",        type: "Shore/Boat", lat: 50.213,  lon: -5.479 },
  { name: "Tintagel",       type: "Shore",      lat: 50.668,  lon: -4.758 },
];

function windyUrl(lat, lon) {
  return `https://www.windy.com/${lat}/${lon}?${lat},${lon},12`;
}

function WindyMarks() {
  return (
    <div className="mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8">
      <div className="mb-4">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-300">Wind &amp; Weather by Location</p>
        <p className="mt-1 text-sm text-slate-400">Open Windy.com centred on a popular fishing mark</p>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {windyMarks.map((mark) => (
          <a
            key={mark.name}
            href={windyUrl(mark.lat, mark.lon)}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col gap-1 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 transition hover:border-cyan-400/40 hover:bg-cyan-400/10"
          >
            <span className="text-sm font-semibold text-white group-hover:text-cyan-300 transition">{mark.name}</span>
            <span className="text-xs text-slate-400">{mark.type}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default function FishingConditionsPage() {
  const navigate = useNavigate();

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Fishing Conditions – Weather, Tides & Swell | Redruth Sea Angling Association"
        description="Live Cornwall fishing conditions including weather, wind speed, wave height, swell height, tides, moon phase, sea temperature and air temperature. Updated daily for sea anglers fishing the Cornish coast. Includes Cornwall sea fish reports and catch reports."
        keywords="fishing conditions Cornwall, Cornwall sea fishing weather, tide times Cornwall, wave height Cornwall, swell forecast Cornwall, moon phase fishing, sea temperature Cornwall, air temperature, wind speed fishing, Redruth sea angling, Cornish coast fishing forecast, Cornwall sea fish reports, Cornwall catch reports, sea fishing catch reports Cornwall, Cornish sea fish reports"
        url="https://www.redruthseaanglingassociation.co.uk/fishing-conditions"
        image="https://www.redruthseaanglingassociation.co.uk/assets/scenic_background.png"
      />
      <div className="mx-auto max-w-7xl px-4 pt-4 pb-2 sm:px-6 lg:px-8">
        <div className="mb-4 flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white"
          >
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">Fishing Conditions</h1>
          </div>
        </div>
      </div>
      <WindyMarks />
      <section id="tideweather">
        <TideWeather />
      </section>
    </div>
  );
}
